console.log("🧪 Running custom AR test script for product");
        var ar_action = "add_to_cart";
        var ar_action_text = "Add to cart";
        var iphone = false;
        var android = false;
        var product;
        var baseUrl = "https://agile-bayou-17706.herokuapp.com";
        var isDekstopDevice = false;
        
        function sendTrackingDetails(action_type = '') {
          console.log("sendTrackingDetails:start")
          var data = {
            action_type: action_type,
            shop: Shopify.shop,
            product_id: product ? product.id : '',
            product_name: product ? product.title : '',
            price: product ? product.price / 100 : 0,
            variant_id: product ? product.variants[0].id : '',
            device: iphone ? 'iphone' : 'android'
          }
          
          console.log(data);
        
          fetch(baseUrl + "/tracking", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            .then((response) => response.json())
            .then((data) => {
              // console.log("data posted");
            })
            .catch((error) => {
              //console.error(error);
              // alert('an error occured')
            });
        }
        
        function addItemToCart() {
          if (ar_action === "checkout") {
            sendTrackingDetails('checkout_click');
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  quantity: 1,
                  id: document.getElementsByName("id")[0].value,
                }),
              })
              .then((response) => response.json())
              .then((data) => {
                window.location.href = "/checkout";
              })
              .catch((error) => {
                console.error("Error:", error);
                // alert('an error occured')
              });
          } else {
            sendTrackingDetails('atc_click');
            window.location.href = "/checkout";
            document.getElementsByName("add")[0].click();
          }
        }
        
        function getShopArSettings() {
          var ua = navigator.userAgent.toLowerCase();
          var android = ua.indexOf("android") > -1;
          var iphone = /iPhone/i.test(navigator.userAgent) && /Safari/i.test(navigator.userAgent);
        
          if (iphone || android) {
            console.info('Script-tag: Mobile Device');
            fetch(location.protocol + "//" + location.host + location.pathname + ".js")
              .then(async (data) => {
                data = await data.json();
                const firstSku = data.variants?.[0]?.sku || 'No SKU found';
                console.log("SKU from .js data:", firstSku);
                let price = null;
              let varientId;
              if (jQuery('.product-single__variants').length > 0) {
                const selectedVarientId = jQuery('.product-single__variants').find(":selected").val();
                for (let index = 0; index < data.variants.length; index++) {
                  const variant = data.variants[index];
                  if (variant.id === parseInt(selectedVarientId)) {
                    varientId = "__" + variant.id;
                    price = variant.price / 100;
                  }
                }
              }
                let uploadedFile;
                const tags = data.tags;
                console.log('Debug - Found Tags -', tags);
                for (let tag of tags) {
                  const tagNamePrefix_ios = "uploaded_image:";
                  const tagNamePrefix_android = "uploaded_image_android:";
                  if (tag.indexOf(tagNamePrefix_ios) >= 0 || tag.indexOf(tagNamePrefix_android) >= 0) {
                    uploadedFile = tag.replace(tagNamePrefix_android, "").replace(tagNamePrefix_ios, "");
                    break;
                  }
                }
        
                // If you don't care about tags anymore, we can skip the `if (!uploadedFile)` check
                // and always show the static button
                console.log("Building view in your space button for QR Code");
                price = price ? price : data.price / 100;
        
                console.info('Price - ', price);
                var title = encodeURI(data.title);
                var vendor = encodeURI(data.vendor);
                // ✅ STATIC LINK TO USDZ MODEL
                var callToAction = encodeURI(ar_action_text);
                const baseUrl = "https://ctklzjdipnqkqrwvxnlk.supabase.co/storage/v1/object/public/abani/";
                var staticArLink = `${baseUrl}${firstSku}.usdz#callToAction=${callToAction}&checkoutTitle=${title}&checkoutSubtitle=${vendor}&price=${price}`;
                  console.log(staticArLink);
                var link = document.createElement("a");
                link.id = "ar-link";
                link.rel = "ar";
                link.href = staticArLink;
                //link.setAttribute("target", "_blank"); // optional: opens in new tab
                // link.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0114/7761/4649/files/Group_4182.svg" class="white" width="100%">';


                link.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0114/7761/4649/files/Group_412282.png" class="white" width="100%">';
                 // link.innerHTML = '<button style="cursor: pointer; font-size: 0.875rem; line-height: 0.7875rem; letter-spacing: 0.0175rem; padding: 0.96875rem 2.125rem 1.15625rem; display: flex; justify-content: center; align-items: center; gap: 0.25rem; background-color: rgb(240, 235, 227); text-transform: uppercase; border: 1px solid transparent; border-radius: 0px; color: rgb(0, 0, 0); font-weight: 700; font-family: trade-gothic-next, sans-serif; margin: 0px; max-height: 2.9375rem;">View in room<svg class="transparent-block-icon__svg" width="16.8" height="16.8" viewBox="0 0 16.8 16.8" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 1.5rem; height: 1.5rem;"><path d="M8.41953 3.66773C8.34078 3.6393 8.25547 3.6393 8.17891 3.66773L3.66391 5.32148L8.29922 7.14367L12.9345 5.32367L8.41953 3.66773ZM3.39922 11.3371C3.39922 11.4837 3.49109 11.6149 3.62891 11.6652L7.94922 13.249V7.75617L3.39922 5.96898V11.3371ZM8.64922 13.249L12.9695 11.6652C13.1073 11.6149 13.1992 11.4837 13.1992 11.3371V5.96898L8.64922 7.75617V13.2468V13.249ZM7.93828 3.0093C8.17234 2.92398 8.42828 2.92398 8.66016 3.0093L13.2102 4.67836C13.6236 4.8293 13.8992 5.22305 13.8992 5.66492V11.3371C13.8992 11.7768 13.6236 12.1705 13.2102 12.3237L8.66016 13.9905C8.42609 14.0759 8.17016 14.0759 7.93828 13.9905L3.38828 12.3215C2.97484 12.1705 2.69922 11.7768 2.69922 11.3371V5.66492C2.69922 5.22523 2.97484 4.83148 3.38828 4.67836L7.93828 3.0093Z" fill="black"></path></svg></button>';
                // jQuery(link).insertBefore('.product-form button#AddToCart');
                    // jQuery(link).insertBefore('.product-gallery-container .product-image-container');
                jQuery(link).insertAfter('.product-gallery-container .product-image-container');
                
                // Optional popup toggle
                /*jQuery("#ar-link").click(function (e) {
                  console.log("click me!!", firstSku);
                  //e.preventDefault(); // prevents link from opening immediately
                  // jQuery('#qr_popup-6085748816390719').toggle();
                  const baseUrl = "https://ctklzjdipnqkqrwvxnlk.supabase.co/storage/v1/object/public/abani/";
                  const arUrl = `${baseUrl}${firstSku}.usdz#callToAction=Add%20to%20cart&checkoutTitle=Abani%20Rugs&checkoutSubtitle=You're%20experiencing%20the%20real%20product%20size`;
                  console.log("Opening AR link:", arUrl);
                  window.location.href = arUrl;
                  //window.open(arUrl, '_blank'); // or use window.location.href = arUrl for same-tab
                });*/
              });
            // You can add AR launch code here for mobile if needed
          } else {
            var isDekstopDevice = true;
            console.info('Script-tag: Desktop Device');
            return;
          }
        
          // Mobile fetch block for AR settings
          fetch(baseUrl + "/ar-settings?shop=" + Shopify.shop, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => response.json())
            .then((data) => {
              if (data.ar_action) {
                ar_action = data.ar_action;
              }
              if (data.ar_action_text) {
                ar_action_text = data.ar_action_text;
              }
              console.info("Building view in your space button from fetch success:");
              addViewInSpaceButton();
            })
            .catch((error) => {
              console.info("Building view in your space button from fetch error");
              addViewInSpaceButton();
            });
        }
        
        
        
        function addViewInSpaceButton(optionSizeSelected) {
          var currency = "$";
          if (typeof Shopify != "undefined") {
            currency = currencySymbols(Shopify.currency.active);
            if (currency == '' || currency == null || typeof currency === 'undefined') {
              currency = '$';
            }
          }
        
          if (window.location.pathname.indexOf('/products/') === -1) {
            console.log("not in product page");
            return;
          } else {
            console.log("in product page");
          }
          console.log("fetching product data...");
          fetch(location.protocol + "//" + location.host + location.pathname + ".js")
            .then(async (data) => {
              data = await data.json();
        
              const tags = data.tags;
              product = data;
              let uploadedFile = null;
              let price = null;
              let varientId;
              if (jQuery('.product-single__variants').length > 0) {
                const selectedVarientId = jQuery('.product-single__variants').find(":selected").val();
                for (let index = 0; index < data.variants.length; index++) {
                  const variant = data.variants[index];
                  if (variant.id === parseInt(selectedVarientId)) {
                    varientId = "__" + variant.id;
                    price = variant.price / 100;
                  }
                }
              }
              if (optionSizeSelected && !varientId) {
                for (let index = 0; index < data.variants.length; index++) {
                  const variant = data.variants[index];
                  if (variant.title === optionSizeSelected) {
                    varientId = "__" + variant.id;
                    price = variant.price / 100;
                  }
                }
                console.log('If Part - optionSizeSelected');
                for (let tag of tags) {
                  if (tag.indexOf(varientId) >= 0) {
                    if (tag.indexOf('uploaded_image_android:') >= 0) {
                      uploadedFile = tag.replace("uploaded_image_android:", "");
                    } else {
                      uploadedFile = tag.replace("uploaded_image:", "");
                    }
                    console.log("uploaded file is found");
                    break;
                    // break; // want to get the last entry
                  }
                }
                if (!uploadedFile) {
                  for (let tag of tags) {
                    let tagNamePrefix = "uploaded_image:";
                    if (android) {
                      tagNamePrefix = "uploaded_image_android:";
                    }
                    if (tag.indexOf(tagNamePrefix) >= 0) {
                      uploadedFile = tag.replace(tagNamePrefix, "");
                      console.log("uploaded file is found");
                      // break; // want to get the last entry
                    }
                  }
                }
              }
              if (!uploadedFile) {
                for (let tag of tags) {
                  let tagNamePrefix = "uploaded_image:";
                  if (android) {
                    tagNamePrefix = "uploaded_image_android:";
                  }
                  if (tag.indexOf(tagNamePrefix) >= 0) {
                    uploadedFile = tag.replace(tagNamePrefix, "");
                    console.log("uploaded file is found");
                    // break; // want to get the last entry
                  }
                }
              }
        
              if (!uploadedFile) {
                console.log("uploaded file is not found");
                return;
              }
        
              var productId = data.id;
              price = price ? price : data.price / 100;
        
              console.info('Price - ', price);
              var title = data.title;
              var vendor = data.vendor;
              // var currency = ShopifyAnalytics.meta.currency;
        
              // console.log("title: " + title);
              // console.log("vendor: " + vendor);
              // console.log("price: " + price);
              // console.log("currency: " + currency);
        
              var callToAction = encodeURI(ar_action_text);
              var link = document.createElement("a");
              link.href =
                uploadedFile +
                "#callToAction=" +
                callToAction +
                "&checkoutTitle=" +
                title +
                "&checkoutSubtitle=" +
                vendor +
                "&price=" +
                price +
                " " +
                currency;
              link.id = "ar-link";
              link.rel = "ar";
              if (android) {
                link.href =
                  "intent://arvr.google.com/scene-viewer/1.0?file=" +
                  uploadedFile +
                  "#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;";
              }
              if (window.location.href.indexOf("therugcollective") > -1 || window.location.href.indexOf("astoswatches") > -1) {
                console.log('Cunsumer - The Rug Collective');
                link.innerHTML =
                  '<img src="https://arspar.s3.eu-central-1.amazonaws.com/arspar/view-in-ar-black.png" class="black" width="100%">';
              } else if (window.location.href.indexOf("pictoset") > -1) {
                link.innerHTML =
                  '<img src="https://arspar.s3.eu-central-1.amazonaws.com/arspar/view-in-ar-pictoset.png" class="black" width="100%">';
              } else {
                console.log('Cusnumer - Other');
                link.innerHTML =
                  '<img src="https://arspar.s3.eu-central-1.amazonaws.com/arspar/view-in-ar.png" class="white"  width="100%">';
              }
            
              
            
              link.addEventListener(
                "message",
                function (event) {
                  console.log({
                    event
                  });
                  if (event.data == "_apple_ar_quicklook_button_tapped") {
                    //            addItemToCart();
                  }
                },
                false
              );
        
              jQuery.getScript("https://arspar.s3.eu-central-1.amazonaws.com/arspar/jquery.cookie.js", function () {
                var addtocartbtnToFind = [
                  'ProductForm__Option',
                  'ProductForm__AddToCart',
                  'add-to-cart',
                  'AddToCart--product-template',
                  'product-form__cart-submit',
                  'button-cart',
                ]
                let addtocartbtnToFindclass;
                for (let i = 0; i < addtocartbtnToFind.length; i++) {
                  if ('button[class*=' + addtocartbtnToFind[i] + ']') {
                    $('.' + addtocartbtnToFind[i]).addClass('ar_module_btn');
                  }
                }
                const selectedVarientId = jQuery('.ProductForm__Option').find(":selected").val();
                console.log(selectedVarientId);
                jQuery.cookie("product_" + selectedVarientId, "close", {
                  expires: 14
                });
                
                link.addEventListener(
                  "click",
                  function (event) {
                    var CookieValue = jQuery.cookie("product_" + selectedVarientId);
                    console.log(CookieValue + '123');
                    if (CookieValue == undefined || CookieValue == null || CookieValue == 'close') {
                      jQuery('.ar_module_btn').trigger("click");
                      jQuery.cookie("product_" + selectedVarientId, "open", {
                        expires: 14
                      });
                      sendTrackingDetails('button_click');
                      sendTrackingDetails('atc_click');
                      sendTrackingDetails('checkout_click');
                    }
                  },
                  false
                );
              });
        
              var elementsToFind = [
                      "#arspar-view-model-btn",
                      '.flexslider.product_gallery.product_images',
                      'div.grid__item.product-single__media-group>noscript',
                      '#product-large-images',
                      'div.product-single__photos.slick-slider',
                      'div.product-single__photos.product-featured-image',
                      'div.product-single__photos.slick-initialized.slick-slider>ul',
                      'div.product-single__photos.product-featured-image',
                      '.product-gallery--viewer.product-gallery--has-media',
                      '.product__main-photos-wrapper',
                      '.product-gallery__carousel-wrapper',
                      'div.product__primary-image-wrapper',
                      'div.featured-image-div-product-template.main-image-product-template',
                      'div.product-detail__images-container',
                      'div.product__media-container',
                      'div.product_gallery',
                      'div.product-item-wrap.large-img',
                      'div.box__product-gallery',
                      'div.product-single__media-group>noscript',
                      'div.page-width div.product__media-container>button',
                      '.photos__item.photos__item--main>noscript',
                      'div.product__photo.grid__item>noscript',
                      '#ProductMediaGroup-product-template .slick__controls.slick-slider',
                      'div.product-photo-container>noscript',
                      '#productPhotoContainer-product-template',
                      '.product-gallery--viewer.product-gallery--has-media',
                      '.product__main-photos-wrapper',
                      '.product-gallery__carousel-wrapper',
                      'div.product__primary-image-wrapper',
                      'div.featured-image-div-product-template.main-image-product-template',
                      'div.product-detail__images-container',
                      'div.product__media-container',
                      'div.product_gallery',
                      'div.product-item-wrap.large-img',
                      'div.product-layout-images div.productImgSlider',
                      'div.product__main-photos',
                      'div.product-single__photos',
                      'div.box__product-gallery',
                      '.grid.product-single>noscript',
                      'photos__item.photos__item--main',
                      '.Product__Gallery.Product__Gallery--stack.Product__Gallery--withThumbnails',
                      'div.Product__Gallery',
                      'div#product-photos',
                      '.product__media-wrapper'
                  ]
        
              let elementToAddAfter;
              for (let elem of elementsToFind) {
                elementToAddAfter = document.querySelector(elem);
                if (elementToAddAfter) {
                  break;
                }
              }
        
              if (elementToAddAfter) {
                var elementToHide = document.querySelector("[data-shopify-xr]");
        
                if (elementToHide) {
                  elementToHide.style.display = "none";
                }
                elementToAddAfter.parentNode.insertBefore(
                  link,
                  elementToAddAfter.nextSibling
                );
        
                // console.log({ elementToAddAfter })
                if (elementToAddAfter) {
                  // add new form element
                  var newElement = document.createElement('input');
                  newElement.name = "properties[arspar]";
                  newElement.value = "arspar";
                  newElement.type = "hidden";
                  insertAfterElem(newElement, document.getElementsByName("add")[0]);
        
                  sendTrackingDetails('button_view');
                }
              }
            })
            .catch((err) => console.log({
              err
            }));
        }
        
        
        function insertAfterElem(newElement, targetElement) {
          if (targetElement) {
            // target is what you want it to go after. Look for this elements parent.
            var parent = targetElement.parentNode;
        
            // if the parents lastchild is the targetElement...
            if (parent.lastChild == targetElement) {
              // add the newElement after the target element.
              parent.appendChild(newElement);
            } else {
              // else the target has siblings, insert the new element between the target and it's next sibling.
              parent.insertBefore(newElement, targetElement.nextSibling);
            }
          }
        }
        
        function currencySymbols(currency) {
          let symbols = {
            "USD": "$",
            "CAD": "$",
            "EUR": "%E2%82%AC",
            "AED": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯.ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¥.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "AFN": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¹",
            "ALL": "Lek",
            "AMD": "ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¤ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã¢â‚¬Å“ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬.",
            "ARS": "$",
            "AUD": "$",
            "AZN": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¼ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â°ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.",
            "BAM": "KM",
            "BDT": "ÃƒÆ’Ã†â€™ ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³",
            "BGN": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â»ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â².",
            "BHD": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯.ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¨.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "BIF": "FBu",
            "BND": "$",
            "BOB": "Bs",
            "BRL": "R$",
            "BWP": "P",
            "BYN": "ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“ÃƒÆ’Ã¢â‚¬ ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±.",
            "BZD": "$",
            "CDF": "FrCD",
            "CHF": "CHF",
            "CLP": "$",
            "CNY": "CNÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¥",
            "COP": "$",
            "CRC": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡",
            "CVE": "CV$",
            "CZK": "KÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "DJF": "Fdj",
            "DKK": "kr",
            "DOP": "RD$",
            "DZD": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯.ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "EEK": "kr",
            "EGP": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬.ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "ERN": "Nfk",
            "ETB": "Br",
            "GBP": "ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£",
            "GEL": "GEL",
            "GHS": "GHÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµ",
            "GNF": "FG",
            "GTQ": "Q",
            "HKD": "$",
            "HNL": "L",
            "HRK": "kn",
            "HUF": "Ft",
            "IDR": "Rp",
            "ILS": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª",
            "INR": "ÃƒÆ’Ã†â€™ ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¸ÃƒÆ’Ã†â€™ ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™ ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾",
            "IQD": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯.ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¹.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "IRR": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â·ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¼",
            "ISK": "kr",
            "JMD": "$",
            "JOD": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯.ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "JPY": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¥",
            "KES": "Ksh",
            "KHR": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¸ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Âº",
            "KMF": "FC",
            "KRW": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©",
            "KWD": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯.ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã¢â‚¬ ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "KZT": "ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‹Å“ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³.",
            "LBP": "ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾.ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "LKR": "SL Re",
            "LTL": "Lt",
            "LVL": "Ls",
            "LYD": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯.ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "MAD": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯.ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "MDL": "MDL",
            "MGA": "MGA",
            "MKD": "MKD",
            "MMK": "K",
            "MOP": "MOP$",
            "MUR": "MURs",
            "MXN": "$",
            "MYR": "RM",
            "MZN": "MTn",
            "NAD": "N$",
            "NGN": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦",
            "NIO": "C$",
            "NOK": "kr",
            "NPR": "ÃƒÆ’Ã†â€™ ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¤ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¨ÃƒÆ’Ã†â€™ ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¥ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¤ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â°ÃƒÆ’Ã†â€™ ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¥ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡",
            "NZD": "$",
            "OMR": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±.ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¹.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "PAB": "B/.",
            "PEN": "S/.",
            "PHP": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±",
            "PKR": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¨",
            "PLN": "zÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡",
            "PYG": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â²",
            "QAR": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±.ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "RON": "RON",
            "RSD": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â´ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¸ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚ÂÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.",
            "RUB": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.",
            "RWF": "FR",
            "SAR": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±.ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "SDG": "SDG",
            "SEK": "kr",
            "SGD": "$",
            "SOS": "Ssh",
            "SYP": "ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾.ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "THB": "ÃƒÆ’Ã†â€™ ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¸ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿",
            "TND": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯.ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª.ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "TOP": "T$",
            "TRY": "TL",
            "TTD": "$",
            "TWD": "NT$",
            "TZS": "TSh",
            "UAH": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â´",
            "UGX": "USh",
            "UYU": "$",
            "UZS": "UZS",
            "VEF": "Bs.F.",
            "VND": "ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â«",
            "XAF": "FCFA",
            "XOF": "CFA",
            "YER": "ÃƒÆ’Ã†â€™Ãƒâ€¹Ã…â€œÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±.ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã¢â‚¬Â¦ .ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â",
            "ZAR": "R",
            "ZMK": "ZK",
            "ZWL": "ZWL$"
          }
        
          return symbols[currency] || ''
        }
        
        getShopArSettings();
        
        jQuery(function () {
          jQuery('.swatch :radio').change(function () {
            if (!isDekstopDevice) {
              var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
              var optionValue = jQuery(this).val();
              //remove element - ar-link
              if (optionValue) {
                if (jQuery('#ar-link').length) {
                  jQuery('#ar-link').remove();
                }
                addViewInSpaceButton(optionValue);
              }
            }
          });
        });